import { render, staticRenderFns } from "./RAnchoredPopup.vue?vue&type=template&id=553ee547&scoped=true&"
import script from "./RAnchoredPopup.vue?vue&type=script&lang=js&"
export * from "./RAnchoredPopup.vue?vue&type=script&lang=js&"
import style0 from "./RAnchoredPopup.vue?vue&type=style&index=0&id=553ee547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ee547",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
